module.exports = __webpack_public_path__ + "assets/4thProportional.fba4f7d749492fdbf69a779c84621546.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/4thProportional.gmt
// module id = 881
// module chunks = 0